import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Button,
    Flex,
    Stack,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    useColorModeValue,

} from '@chakra-ui/react';
import { useService } from 'contexts/ServiceContext';
import CInput from 'components/CInput';
import CButton from 'components/CButton';
import ImageUpload from 'components/ImageUpload';

export default function NewServiceCategory() {
    const { createCategory, getSingleCategory, updateCategory } = useService();

    const navigate = useNavigate();
    const params = useParams();

    const textColor = useColorModeValue('secondaryGray.900', 'white');

    const [validated, setValidated] = useState(false);
    const [isImageValid, setIsImageValid] = useState(true);
    const [categoryDetail, setCategoryDetail] = useState({
        name: '',
        icon: null,
        is_active: 1,
    });

    useEffect(() => {
        fetchSingleCategory();

        return () => {
            setCategoryDetail({
                name: '',
                icon: null,
                is_active: 1,
            })
        };
    }, [params.id]);

    const fetchSingleCategory = async () => {
        if (params.id) {
            const category = await getSingleCategory(params.id);
            if (category) {
                setCategoryDetail(category.category);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setValidated(true);

        if (!categoryDetail.name || !categoryDetail.icon || !isImageValid) return;

        try {
            const formData = new FormData();
            formData.append('name', categoryDetail.name);
            formData.append('icon', categoryDetail.icon);
            formData.append('is_active', categoryDetail.is_active ? 1 : 0);

            if (params.id) {
                const data = await updateCategory(params.id, formData);
                if (!data.error) {
                    navigate('/admin/service/category');
                }
            } else {
                const data = await createCategory(formData);
                if (!data.error) {
                    navigate('/admin/service/category');
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Flex direction="column" minH="100vh" align="start" top="0" pt={{ sm: '125px', lg: '75px' }} position="relative" w="100%">
            <Tabs w="100%">
                <TabPanels mt="24px" maxW="100%" w="100%" mx="auto">
                    <TabPanel w="100%" p="0px" mx="auto">
                        <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                            Category Info
                        </Text>
                        <form onSubmit={handleSubmit}>
                            <Flex direction="row" w="100%" justify="space-between">
                                <Stack direction="column" spacing="20px" w={{ base: "100%", md: "48%" }}>
                                    <CInput
                                        label="Name"
                                        type="text"
                                        value={categoryDetail.name}
                                        onChange={(value) => setCategoryDetail({ ...categoryDetail, name: value })}
                                        required={true}
                                        validated={validated}
                                        placeholder="Enter category name"
                                        w="100%"
                                        mb="8px !important"
                                    />
                                    <CInput
                                        label="Active"
                                        type="switch"
                                        colorScheme="orange"
                                        value={categoryDetail.is_active}
                                        onChange={(value) =>
                                            setCategoryDetail({
                                                ...categoryDetail,
                                                is_active: value,
                                            })
                                        }
                                        validated={validated}
                                        w="100%"
                                        mb="8px !important"
                                    />
                                    <ImageUpload
                                        label="Icon"
                                        existingImage={categoryDetail.icon && categoryDetail.icon instanceof File ? URL.createObjectURL(categoryDetail.icon) : categoryDetail.icon}
                                        onImageSelect={(file) => setCategoryDetail({ ...categoryDetail, icon: file })}
                                        validated={validated}
                                        setValidated={setValidated}
                                        required={true}
                                        validateDimensions={true}
                                        setIsImageValid={setIsImageValid}
                                        width={200}
                                        height={200}
                                    />
                                </Stack>
                            </Flex>
                            <Flex justify="flex-end" align="center" mt="44px" gap="3">
                                <Button
                                    variant="darkBrand"
                                    fontSize="sm"
                                    borderRadius="10px"
                                    w={{ base: '128px', md: '148px' }}
                                    h="46px" type="button"
                                    bg="gray"
                                    color="white"
                                    _hover={{ bg: 'gray.600' }}
                                    onClick={() => navigate('/admin/service/category')}>
                                    Cancel
                                </Button>
                                <CButton
                                    w={{ base: '128px', md: '148px' }}
                                    h="46px"
                                    type="submit">
                                    Submit
                                </CButton>
                            </Flex>
                        </form>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Flex>
    );
}
